'use client'
import { Component, ReactNode } from 'react'
import { ErrorComponent } from '@/types'
type ErrorBoundaryProps = { errorComponent: ErrorComponent; children?: ReactNode; onError?: (err: Error) => void }
class ErrorBoundary extends Component<ErrorBoundaryProps, { error?: Error }> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { error: undefined }
  }

  resetError = () => {
    this.setState({ error: undefined })
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { error }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  componentDidCatch(error: Error, _info: any) {
    this.props.onError?.(error)
  }

  render() {
    if (this.state.error) {
      const Fallback = this.props.errorComponent
      return <Fallback error={this.state.error} reset={this.resetError} />
    }

    return this.props.children
  }
}

export default ErrorBoundary
